import { PropsWithChildren } from "react";

type Props = PropsWithChildren;
export function Row({ children }: Props) {
  return <div className={"flex space-x-4"}>{children ?? null}</div>;
}
